import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../components/Breadcrumb'


export default function PageRules() {
    const [tab, setTab] = useState('step1rulesTab');
    const handleTabClick = (tabId) => {
        setTab(tabId);
    };


    return (
        <>
            <Breadcrumb className="" breadcrumbIcon="UserCircleSvg" breadcrumbHeading="Rules" />
            <div className="container-lg cl-custome3">
                <div className="common-box">
                    <div className="common-box rules-bx">
                        <div className="alb-tabs">
                            {/* Step 1 & Step 2 Rules Tabing btn */}
                            <div className="common-tabs-bx">
                                <div className={`ctb-item ${tab === 'step1rulesTab' ? 'active' : ''}`} onClick={() => handleTabClick('step1rulesTab')}>Step 1</div>
                                <div className={`ctb-item ${tab === 'step2rulesTab' ? 'active' : ''}`} onClick={() => handleTabClick('step2rulesTab')}>Step 2</div>
                                  <div className={`ctb-item ${tab === 'step3rulesTab' ? 'active' : ''}`} onClick={() => handleTabClick('step3rulesTab')}>Instant</div>
                            </div>
                            {/* --- Step 1 & Step 2 Rules Tabing btn end --- */}
                        </div>
                        <div className="alb-data">
                            {/* Step 1 Rules btn */}
                            <div className={`row row-gap-0 ${tab === 'step1rulesTab' ? '' : 'd-none'} `} id="acActive">

                                 <div className="legal-content">
                                    <p>At FundedSkill, we know skilled traders need the right environment to apply their methods effectively. Our setup offers broad market access and practical leverage, free from overly restrictive policies.</p>
                                </div>
                                <div className="legal-content">
                                    <div className="legal-heading">1. Trading Flexibilit</div>
                                    <p>At FundedSkill, we understand that serious traders don’t just need market access — they need the right conditions to execute with precision.</p>
                                    <p>Our infrastructure is designed to support strategic trading across multiple asset classes, with meaningful leverage and zero unnecessary restrictions.</p>
                                   <p>This is your edge. Use it wisely.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.1 Tradable Instruments</div>
                                    <p>We provide access to a diversified selection of global markets, allowing you to specialize or diversify based on your strategy and risk tolerance.</p>
                                    <p>You can trade:</p>
                                    <ul>
                                        <li>Foreign Exchange (Forex)</li>
                                        <li>Precious Metals</li>
                                        <li>Global Indices</li>
                                        <li>Energy Commodities</li>
                                        <li>Cryptocurrencies</li>
                                    </ul>
                                    <p className='mt-3'>Built for flexibility. Structured for performance.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.2 Leverage Policy</div>
                                    <p>Leverage is a tool — and in the hands of a disciplined trader, it becomes a strategic advantage.</p>
                                    <p>To support capital efficiency while maintaining responsible risk parameters, we offer:</p>
                                    <table className="custom-table mt-4 mb-2">
                                        <thead>
                                            <tr>
                                                <th>Asset Class</th>
                                                <th>Leverage</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td >Forex</td>
                                                <td>1:100</td>
                                               
                                            </tr>
                                            <tr>
                                                <td >Metals</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Indices</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Energies</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Crypto</td>
                                                <td>1:50</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>Our leverage structure is designed to give you operational room — even during volatile market conditions — without encouraging reckless exposure.</p>
                                    <p>Trade smart. Trade structured. Trade with intent.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2. Strategy & Execution Freedom</div>
                                    <p>At FundedSkill, we believe professional traders perform best when unnecessary restrictions are removed.</p>
                                    <p>We don’t interfere with your strategy. We provide the structure — you provide the edge.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.1 Weekend & Overnight Holding</div>
                                    <p>Markets don’t operate on artificial timelines — and neither should you.</p>
                                    <p>Some setups require patience. Others need room to develop across sessions. That’s why we impose no restrictions on overnight or weekend holding.</p>
                                    <p>You are free to:</p>
                                    <ul>
                                        <li>Hold positions overnight</li>
                                        <li>Carry trades through multiple sessions</li>
                                        <li>Maintain swing trades over the weekend</li>
                                    </ul>
                                    <p className='mt-3'>Whether you're positioning around macro narratives or riding a sustained trend, your trades won’t be closed due to arbitrary firm policies.</p>
                                    <p>Your strategy. Your timing.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.2 News Trading — Fully Allowed</div>
                                    <p>News is not an exception to the market. It is the market.</p>
                                    <p>We allow news trading in all forms, including:</p>
                                    <ul>
                                        <li>Central bank decisions</li>
                                        <li>Major economic releases</li>
                                        <li>Inflation data</li>
                                        <li>Geopolitical developments</li>
                                    </ul>
                                    <p className='mt-3'>If your edge is built around fundamentals or short-term volatility, you are free to execute.</p>
                                    <p>Fast markets create opportunity — and disciplined traders know how to navigate them.</p>
                                    <p>You are trusted to trade responsibly, even when volatility expands.</p>
                                </div>

                                <div className="legal-content">
                                    <p>At FundedSkill, you are allowed to place multiple trades on the same pair; however, how they are classified depends on the time gap between them. To treat trades as separate orders, there must be at least a three-minute gap.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading mt-3">2.3 Take Your Time</div>
                                    <p>Performance thrives without artificial pressure.</p>
                                    <p>That’s why there is no maximum time limit to complete your challenge.</p>
                                    <p>Whether it takes days or weeks, you can progress at your own pace. We care about consistency — not speed.</p>
                                    <p className='mt-3'>Trade when conditions align.</p>
                                    <p > Wait when they don’t.</p>
                                    <p> Let your system work.</p>
                                
                                    <div className="legal-heading mt-3">3. Trading Framework</div>
                                    <p>At FundedSkill, our evaluation process is built around two structured phases: Step 1 and Step 2.</p>
                                    <p>Each phase is designed to assess what truly matters in professional trading:</p>
                                    <ul>
                                        <li>Discipline</li>
                                        <li>Consistency</li>
                                        <li>Risk Management</li>
                                        <li>Emotional Control</li>
                                    </ul>
                                    <p className='mt-3'>Traders who meet all performance objectives while respecting the rules are promoted to a live funded account, where they become eligible for real payouts under their selected profit-sharing plan.</p>
                                    <p>This framework ensures we fund traders who can manage capital — not just generate returns.</p>
                                   
                                   
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Minimum Trading Days</div>
                                    <p>Each evaluation step requires a minimum of 3 separate trading days.</p>
                                    <p>This rule ensures performance consistency and prevents passing the challenge through a single high-risk trade.</p>
                                    <p>Consistency over time is what qualifies you — not one aggressive setup.</p>
                                    
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Trading Inactivity</div>
                                    <p>To maintain an active and fair evaluation environment:</p>
                                    <ul>
                                        <li>Accounts must show regular trading activity.</li>
                                        <li>If there is no activity for 30 consecutive days, the account may be permanently disabled.</li>
                                    </ul>
                                    <p className='mt-3'>This policy ensures evaluation integrity and fair allocation of firm resources.</p>
                                    <p>If you anticipate an extended break, notify the team in advance to avoid unintended violations.</p>
                                    
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Profit Target</div>
                                    <p>To pass each evaluation step, traders must achieve:</p>
                                    <p>10% profit on their challenge account.</p>
                                    <p>The target must be reached while strictly respecting all risk parameters and rules.</p>
                                    <p>Profit without discipline does not qualify.</p>
                                    
                                </div>

                                  <div className="legal-content">
                                    <div className="legal-heading">Risk Management Parameters
                                    <p>Risk control is the foundation of the FundedSkill model.</p>
                                    </div>
                                    </div>
                                    <div className="legal-content">
                                    <div className="legal-heading">Maximum Daily Drawdown – 3%</div>
                                    <p>The daily drawdown is calculated as:</p>
                                    <p>3% of the higher value between your starting balance or starting equity at the beginning of the trading day.</p>
                                   <ul>
                                    <li>The limit is fixed for the entire day.</li>
                                    <li>It does not expand due to intraday profits.</li>
                                    <li>Both floating and closed losses are counted.</li>
                                   </ul>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Example — Day 1</div>
                                    <p>Starting balance: $500</p>
                                    <p> Daily limit: 3% = $15</p>
                                     <p> Minimum equity allowed: $485</p>
                                     <p className='mt-3'> If equity drops below $485 at any time → breach.</p>
                                </div>

                                   <div className="legal-content">
                                    <div className="legal-heading">Example — Day 2</div>
                                    <p>Balance: $510</p>
                                    <p> Floating profit at start of day: $10</p>
                                     <p>  Starting equity: $520</p>
                                    
                                    <p className='mt-3'>Daily limit: 3% of $520 = $15.60</p>
                                    <p> Minimum equity allowed: $504.40</p>
                                    <p className='mt-3'>Even if profits increase during the day, the drawdown buffer does not increase.</p>
                                    <p>Live equity must always remain above the calculated threshold.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Maximum Overall Drawdown – 6%</div>
                                    <p>The overall drawdown is fixed at:</p>
                                    <p>6% of the initial account balance</p>
                                     <p>  This limit does not change — even if you generate profits.</p>
                                    
                                    <ul>
                                        <li>Both floating and closed losses count.</li>
                                        <li>Equity or balance must remain above 94% of the starting balance at all times.</li>
                                    </ul>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p >Starting balance: $500</p>
                                    <p>Maximum loss allowed: $30</p>
                                     <p> Minimum equity allowed: $470</p>
                                    
                                    <p className='mt-3'>If equity falls below $470 → immediate breach.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Breach Policy</div>
                                    <p >If your equity falls below either:</p>
                                    <ul>
                                        <li>The daily drawdown limit</li>
                                        <li>The overall drawdown limit</li>
                                    </ul>
                                    <p className='mt-3'>Your account will be immediately breached and permanently disabled.</p>
                                     <p>There are no warnings once limits are violated.</p>
                                    
                                    <p>Monitoring live equity is essential.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Additional Notes</div>
                                    <ul>
                                        <li>Trades opened within 3 minutes, on the same symbol and in the same direction, will be treated as one single trade.</li>
                                        <li>The system resets your starting balance and equity at 10:00 PM UTC daily.</li>
                                    </ul>
                                </div> 

                                <div className="legal-content">
                                    <div className="legal-heading">4. Destructive Trading Habits</div>
                                    <p>At FundedSkill, our objective is not just to help traders pass an evaluation — but to help them build habits that sustain long-term performance.</p>
                                    <p>Markets are fast. Emotions are real. Pressure is constant.</p>
                                    <p>But certain behaviors — even if they seem minor in the moment — can quickly escalate into account-damaging decisions.</p>
                                    <p>This section outlines common destructive habits and the standards required to avoid them.</p>
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">4.1 Gambling Behaviour</div>
                                    <p>Trading is probability-based decision making — not chance.</p>
                                    <p>One of the fastest ways to violate risk parameters is by placing oversized positions capable of consuming the majority of your daily drawdown in a single move.</p>
                                    <p>To prevent this:</p>
                                    <p>No single trade may exceed 40% of your daily loss limit.</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p>Account size: $10,000</p>
                                    <p> Daily drawdown: 3% = $300</p>
                                    <p> Maximum loss per trade: $120</p>

                                    <p className='mt-3'>If a single trade (including floating loss) exceeds $120 → violation.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Important Clarification</div>
                                    <ul>
                                        <li>Multiple positions opened on the same pair, in the same direction, within 3 minutes will be treated as a single combined trade.</li>
                                        <li>Combined floating and closed losses must remain within the 40% threshold.</li>
                                        <li>The daily drawdown limit is fixed and does not expand due to realized or unrealized profits.</li>
                                    </ul>
                                    <p className='mt-3'>Structured risk sizing reflects professionalism. Oversizing reflects gambling.</p>
                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">4.2 Conflicted Trade Bias (Opposite Positions)</div>

                                    <p>Strategic clarity is essential.</p>
                                    <p>Opening simultaneous long and short positions on the same instrument creates artificial neutrality and removes directional conviction.</p>
                                    <p>This is not permitted.</p>
                                    </div>


                                     <div className="legal-content">
                                    <div className="legal-heading">Example (Not Allowed)</div>
                                    <ul>
                                        <li>Buy XAUUSD at 3220</li>
                                        <li>Sell XAUUSD at 3240</li>
                                        <li>Holding both positions at the same time</li>
                                    </ul>
                                    <p className='mt-3'>You cannot maintain opposing positions on the same instrument simultaneously.</p>
                                    <p>Instead of hedging against yourself, develop structured directional analysis and manage risk through proper position sizing and stop placement.</p>
                                    <p>Confidence in setup matters.</p>
                                  </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">4.3 Structured Lot Consistency Rule</div>
                                    <p>Position sizing must demonstrate consistency.</p>
                                    <p>For each instrument traded, the smallest lot size in your order history becomes your base lot size.</p>
                                    <p>Any trade placed on that same instrument must not exceed:</p>
                                    <p>5× the base lot size</p>
                                    <p>This rule is applied individually per instrument.</p>
                                    
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Example — XAU/USD</div>
                                    <p>If your smallest historical trade is:</p>
                                    <p>1.0 lot → Base lot = 1.0</p>
                                    <p>You may trade between:</p>
                                    <p>1 lot and 5 lots</p>
                                    <p>Valid examples:</p>
                                    <ul>
                                        <li>1 lot</li>
                                        <li>2 lots</li>
                                        <li>3 lots</li>
                                        <li>4 lots</li>
                                        <li>5 lots</li>
                                    </ul>

                                    <p className='mt-3'>If you open a smaller trade, such as:</p>
                                    <p>0.9 lot → Base lot resets to 0.9</p>
                                    <p>Now your maximum allowed trade becomes:</p>
                                    <p>4.5 lots</p>
                                    
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Additional Notes</div>
                                    <ul>
                                        <li>Trades opened within 3 minutes, on the same symbol and in the same direction, are treated as a single trade.</li>
                                        <li>The assessment is performed per instrument, as lot structures differ across asset classes (Forex, Metals, Crypto, etc.).</li>
                                    </ul> 
                                </div>      

                                 <div className="legal-content">
                                    <div className="legal-heading">In Case of Violation</div>
                                        <p>FundedSkill continuously monitors accounts to ensure compliance with the above standards.</p>
                                        <p>If trading behavior falls outside defined parameters, the account may be reviewed, restricted, or permanently breached.</p>
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">The Principle</div>
                                    <p>We are not here to restrict you.</p>
                                    <p>We are here to eliminate self-destructive patterns that separate short-term luck from long-term skill.</p>

                                    <p className='mt-3'>Trade with structure.</p>
                                    <p> Size with intent.</p>
                                    <p>Protect capital first.</p>
                                </div>    

                                
                                 <div className="legal-content">
                                    <div className="legal-heading">5. Payout Policy</div>
                                    <p>At FundedSkill, performance is rewarded transparently and consistently</p>
                                    <p> Our payout structure is designed to incentivize disciplined profitability — not short-term spikes.</p>

                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">Payout Eligibility</div>
                                    <p>To qualify for any payout, traders must generate a minimum of:</p>
                                    <p> 1% net profit on their live funded account.</p>
                                     <p>This threshold ensures payouts reflect:</p>

                                     <ul>
                                        <li>Meaningful trading performance</li>
                                        <li>Responsible capital management</li>
                                        <li>Sustained profitability</li>
                                     </ul>

                                     <p className='mt-3'>Payouts are based on net profit after respecting all risk parameters and rules.</p>

                                </div>
                                
                                <div className="legal-content">
                                    <div className="legal-heading">Payout Schedule</div>
                                    <p>Traders can select their preferred payout cycle at enrollment:</p>

                                     <ul>
                                        <li>Weekly</li>
                                        <li>Biweekly</li>
                                        <li>Monthly</li>
                                     </ul>

                                     <p className='mt-3'>Each option comes with a defined profit-sharing structure.</p>

                                </div>    

                                <div className="legal-content">
                                    <div className="legal-heading">Profit Share Structure</div>
                                   <table className="custom-table mt-4 mb-2">
                                        <thead>
                                            <tr>
                                                <th>Payout Frequency</th>
                                                <th>Profit Share</th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr>
                                                 <td >Monthly</td>
                                                <td>Up to 100%</td>
                                               
                                            </tr>
                                            <tr>
                                                <td >Biweekly</td>
                                                <td>80%</td>
                                            </tr>
                                            <tr>
                                                <td >Weekly</td>
                                                <td>60%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">Monthly Plan</div>
                                    <p>Traders opting for monthly payouts are eligible to receive up to 100% of their shareable profits, maximizing long-term earnings.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Biweekly & Weekly Plans</div>
                                    <p>For traders who prefer more frequent withdrawals:</p>

                                    <ul>
                                        <li>Biweekly payout → 80% profit share</li>
                                        <li>Weekly payout → 60% profit share</li>
                                    </ul>

                                    <p className='mt-3'>Frequent liquidity comes with adjusted distribution.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Weekly & Biweekly Release Schedule</div>
                                    <p>For weekly and biweekly plans:</p>

                                    <ul>
                                        <li>Payouts are processed every Wednesday</li>
                                        <li>The first payout becomes eligible starting from the second week after the live account is activated</li>
                                    </ul>

                                    <p className='mt-3'>This structure ensures consistent accounting cycles and transparent profit calculation.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">6. Evaluation Fee Refund</div>
                                    <p>At FundedSkill, we believe commitment and performance should be rewarded.</p>

                                    <p>All traders who successfully pass the evaluation process and reach funded status will receive a full refund of their evaluation fee, issued alongside their 4th payout.</p>
                                    <p>This ensures that traders who demonstrate consistency and professionalism are fully compensated — not just through profit share, but through returned capital as well.</p>

                                    <p className='mt-3'>Your performance earns your funding</p>
                                    <p> Your consistency earns your refund.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">7. Disclaimer</div>
                                    
                                </div>  

                                
                                <div className="legal-content">
                                    <div className="legal-heading">Slippage & Volatility Policy</div>
                                    <p>Financial markets are dynamic and, at times, highly volatile. During periods of increased volatility — particularly around major economic releases, geopolitical developments, or unexpected liquidity shifts — slippage may occur.</p>

                                    <p>This means that orders, including stop-loss and pending orders, may be executed at prices different from those requested due to real-time market liquidity and execution conditions provided by liquidity providers.</p>
                                    <p>Please note:</p>

                                     <ul>
                                        <li>Slippage is a natural market phenomenon.</li>
                                        <li>Execution prices cannot be guaranteed during extreme volatility.</li>
                                        <li>Both positive and negative slippage may occur.</li>
                                     </ul>
                                    <p className='mt-3'> If slippage results in a breach of daily or overall drawdown limits, the violation will be considered valid and the account will be treated accordingly.</p>
                                    <p>FundedSkill does not adjust or reverse breaches caused by market-driven execution conditions.</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Built for Consistency. Not Gambling.</div>
                                    <p>FundedSkill is structured to reward disciplined, process-driven traders — not event-driven speculation.</p>

                                    <p>If more than 80% of total profit is generated from:</p>
                                    

                                     <ul>
                                        <li>A single trade</li>
                                        <li>A single high-impact news event</li>
                                        <li>All-in positions during major economic releases</li>
                                        <li>Mirrored or opposing trades across multiple accounts</li>
                                        <li>Strategies designed to intentionally fail one account to pass another</li>
                                     </ul>
                                    <p className='mt-3'> Your account may be subject to review.</p>
                                    <p>We reserve the right to evaluate trade intent, timing, and overall risk structure to ensure fair participation across the program.</p>
                                    <p>Traders who apply structured risk management and consistent execution practices are not affected.</p>
                                </div>
  
  
  

                            </div>

                            {/* Step 2 Rules btn */}
                            <div className={`row row-gap-0 ${tab === 'step2rulesTab' ? '' : 'd-none'} `} id="acActive">
                               
                                 <div className="legal-content">
                                    <p>At FundedSkill, we know skilled traders need the right environment to apply their methods effectively. Our setup offers broad market access and practical leverage, free from overly restrictive policies.</p>
                                </div>
                                <div className="legal-content">
                                    <div className="legal-heading">1. Trading Flexibilit</div>
                                    <p>At FundedSkill, we understand that serious traders don’t just need market access — they need the right conditions to execute with precision.</p>
                                    <p>Our infrastructure is designed to support strategic trading across multiple asset classes, with meaningful leverage and zero unnecessary restrictions.</p>
                                   <p>This is your edge. Use it wisely.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.1 Tradable Instruments</div>
                                    <p>We provide access to a diversified selection of global markets, allowing you to specialize or diversify based on your strategy and risk tolerance.</p>
                                    <p>You can trade:</p>
                                    <ul>
                                        <li>Foreign Exchange (Forex)</li>
                                        <li>Precious Metals</li>
                                        <li>Global Indices</li>
                                        <li>Energy Commodities</li>
                                        <li>Cryptocurrencies</li>
                                    </ul>
                                    <p className='mt-3'>Built for flexibility. Structured for performance.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.2 Leverage Policy</div>
                                    <p>Leverage is a tool — and in the hands of a disciplined trader, it becomes a strategic advantage.</p>
                                    <p>To support capital efficiency while maintaining responsible risk parameters, we offer:</p>
                                    <table className="custom-table mt-4 mb-2">
                                        <thead>
                                            <tr>
                                                <th>Asset Class</th>
                                                <th>Leverage</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td >Forex</td>
                                                <td>1:100</td>
                                               
                                            </tr>
                                            <tr>
                                                <td >Metals</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Indices</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Energies</td>
                                                <td>1:100</td>
                                            </tr>
                                            <tr>
                                                <td >Crypto</td>
                                                <td>1:50</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>Our leverage structure is designed to give you operational room — even during volatile market conditions — without encouraging reckless exposure.</p>
                                    <p>Trade smart. Trade structured. Trade with intent.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2. Strategy & Execution Freedom</div>
                                    <p>At FundedSkill, we believe professional traders perform best when unnecessary restrictions are removed.</p>
                                    <p>We don’t interfere with your strategy. We provide the structure — you provide the edge.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.1 Weekend & Overnight Holding</div>
                                    <p>Markets don’t operate on artificial timelines — and neither should you.</p>
                                    <p>Some setups require patience. Others need room to develop across sessions. That’s why we impose no restrictions on overnight or weekend holding.</p>
                                    <p>You are free to:</p>
                                    <ul>
                                        <li>Hold positions overnight</li>
                                        <li>Carry trades through multiple sessions</li>
                                        <li>Maintain swing trades over the weekend</li>
                                    </ul>
                                    <p className='mt-3'>Whether you're positioning around macro narratives or riding a sustained trend, your trades won’t be closed due to arbitrary firm policies.</p>
                                    <p>Your strategy. Your timing.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.2 News Trading — Fully Allowed</div>
                                    <p>News is not an exception to the market. It is the market.</p>
                                    <p>We allow news trading in all forms, including:</p>
                                    <ul>
                                        <li>Central bank decisions</li>
                                        <li>Major economic releases</li>
                                        <li>Inflation data</li>
                                        <li>Geopolitical developments</li>
                                    </ul>
                                    <p className='mt-3'>If your edge is built around fundamentals or short-term volatility, you are free to execute.</p>
                                    <p>Fast markets create opportunity — and disciplined traders know how to navigate them.</p>
                                    <p>You are trusted to trade responsibly, even when volatility expands.</p>
                                </div>

                                <div className="legal-content">
                                    <p>At FundedSkill, you are allowed to place multiple trades on the same pair; however, how they are classified depends on the time gap between them. To treat trades as separate orders, there must be at least a three-minute gap.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading mt-3">2.3 Take Your Time</div>
                                    <p>Performance thrives without artificial pressure.</p>
                                    <p>That’s why there is no maximum time limit to complete your challenge.</p>
                                    <p>Whether it takes days or weeks, you can progress at your own pace. We care about consistency — not speed.</p>
                                    <p className='mt-3'>Trade when conditions align.</p>
                                    <p > Wait when they don’t.</p>
                                    <p> Let your system work.</p>
                                
                                    <div className="legal-heading mt-3">3. Trading Framework</div>
                                    <p>At FundedSkill, the evaluation process is structured into two phases: Phase 1 and Phase 2.</p>
                                    <p>Each phase is designed to assess:</p>
                                    <ul>
                                        <li>Discipline</li>
                                        <li>Consistency</li>
                                        <li>Risk Management</li>
                                        <li>Capital Preservation</li>
                                    </ul>
                                    <p className='mt-3'>Traders who successfully meet all performance targets while strictly adhering to the rules will be promoted to a Live Funded Account, becoming eligible for real payouts under their selected profit-sharing plan.</p>
                                   
                                   
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Minimum Trading Days</div>
                                    <p>A minimum of 3 separate trading days is required in each phase.</p>
                                    <p>This ensures that performance reflects consistency over time rather than a single high-risk trade achieving the target.</p>
                                    <p>Sustainable results matter more than speed.</p>
                                    
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Trading Inactivity</div>
                                    <p>To maintain an active and fair evaluation environment:</p>
                                    <ul>
                                        <li>Accounts must demonstrate consistent trading activity.</li>
                                        <li>If there is no trading activity for 30 consecutive days, the account may be permanently disabled.</li>
                                    </ul>
                                    <p className='mt-3'>This policy ensures resources are allocated to committed traders and that evaluation results reflect current trading behavior.</p>
                                    <p>If you anticipate a break, notify the team in advance to avoid unintended violations.</p>
                                    
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Profit Target</div>
                                    <ul>
                                        <li>Phase 1 → 8% profit target</li>
                                        <li>Phase 2 → 5% profit target</li>
                                    </ul>
                                    <p className='mt-3'>The profit target must be achieved while remaining fully compliant with all risk parameters and trading rules.</p>
                                    <p>Profit without rule adherence does not qualify.</p>
                                    
                                </div>

                                  <div className="legal-content">
                                    <div className="legal-heading">Risk Parameters
                                    
                                    <p>Risk control remains the foundation of the FundedSkill model.</p>
                                    </div>
                                    </div>
                                    <div className="legal-content">
                                    <div className="legal-heading">Maximum Daily Drawdown – 5%</div>
                                    <p>The daily drawdown is calculated as:</p>
                                    <p>5% of the higher value between your starting balance or starting equity at the beginning of the trading day.</p>
                                   <ul>
                                    <li>The limit is fixed for the day.</li>
                                    <li>It does not increase based on intraday gains.</li>
                                    <li>Both floating and closed losses are included.</li>
                                   </ul>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Example — Day 1</div>
                                    <p>Starting balance: $500</p>
                                    <p>  Daily drawdown limit: $25</p>
                                     <p> Minimum equity allowed: $475</p>
                                     <p className='mt-3'>If equity falls below $475 → breach.</p>
                                </div>

                                   <div className="legal-content">
                                    <div className="legal-heading">Example — Day 2</div>
                                    <p>Balance: $510</p>
                                    <p> Floating profit at start: $10</p>
                                     <p>  Starting equity: $520</p>
                                    
                                    <p className='mt-3'>Daily limit: $26</p>
                                    <p>Minimum equity allowed: $494</p>
                                    <p className='mt-3'>Even if profits increase during the day, the buffer does not expand.</p>
                                    <p>Monitoring live equity is essential.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Maximum Overall Drawdown – 10%</div>
                                    <p>The overall drawdown is fixed at:</p>
                                    <p>10% of the initial account balance</p>
                                    
                                    <ul>
                                        <li>Equity or balance must never fall to or below 90% of the starting balance.</li>
                                        <li>Both floating and closed losses are counted.</li>
                                        <li>The limit does not increase after profits.</li>
                                    </ul>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p >Starting balance: $500</p>
                                    <p>Maximum loss allowed: $50</p>
                                     <p> Minimum equity allowed: $450</p>
                                    
                                    <p className='mt-3'>If equity falls to or below $450 → breach.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Breach Policy</div>
                                    <p >If your equity falls below either:</p>
                                    <ul>
                                        <li>The daily drawdown limit</li>
                                        <li>The overall drawdown limit</li>
                                    </ul>
                                    <p className='mt-3'>Your account will be immediately breached and permanently revoked.</p>
                                     <p>There are no warnings once limits are violated.</p>
                                    
                                    <p>Capital protection is non-negotiable.</p>
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Additional Notes</div>
                                    <ul>
                                        <li>Trades opened within 3 minutes, on the same symbol and in the same direction, will be treated as a single trade.</li>
                                        <li>The system resets starting balance and equity daily at 10:00 PM UTC.</li>
                                    </ul>
                                </div> 

                                <div className="legal-content">
                                    <div className="legal-heading">4. Prohibited & High-Risk Trading Practices</div>
                                    <p>At FundedSkill, our objective is not only to evaluate performance — but to identify traders capable of managing capital responsibly over the long term.</p>
                                    <p>Markets are volatile. Emotions are real.</p>
                                    <p>However, certain behaviors can quickly compromise both individual accounts and the integrity of a professional trading environment.</p>
                                    <p>The following practices are restricted to ensure disciplined participation.</p>
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">4.1 Gambling Behaviour (Excessive Single-Trade Risk)</div>
                                    <p>Trading is a probability-driven discipline — not a one-shot event.</p>
                                    <p>To prevent excessive exposure, no single trade may exceed:</p>
                                    <p>40% of your daily loss limit</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p>Account size: $10,000</p>
                                    <p> Daily drawdown: 5% = $500</p>
                                    <p>  Maximum loss per trade: $200</p>

                                    <p className='mt-3'>If one trade (including floating loss) exceeds $200 → violation.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Important Clarification</div>
                                    <ul>
                                        <li>Multiple positions opened on the same pair, in the same direction, within 3 minutes will be treated as one combined trade.</li>
                                        <li>Combined floating and closed losses must remain within the 40% threshold.</li>
                                        <li>The daily drawdown limit is fixed and does not increase based on realized or unrealized profit.</li>
                                    </ul>
                                    <p className='mt-3'>Professional traders scale within structure.</p>
                                    <p> Oversizing to accelerate results is considered gambling.</p>
                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">4.2 Conflicted Trade Bias (Opposite Positions)</div>

                                    <p>Holding simultaneous long and short positions on the same instrument is not permitted.</p>
                                    <p>This practice creates artificial neutrality and does not reflect clear directional intent.</p>
                                    
                                    </div>


                                     <div className="legal-content">
                                    <div className="legal-heading">Example (Not Allowed)</div>
                                    <ul>
                                        <li>Buy XAUUSD at 3220</li>
                                        <li>Sell XAUUSD at 3240</li>
                                        <li>Holding both positions at the same time</li>
                                    </ul>
                                    <p className='mt-3'>Traders must maintain directional clarity and manage risk through position sizing and stop-loss placement — not internal hedging.</p>
                                    
                                    <p>Confidence in setup is essential.</p>
                                  </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">4.3 Lot Consistency & Scaling Rule</div>
                                    <p>To ensure structured risk progression, position sizing must remain consistent.</p>
                                  
                                    <p>For each instrument:</p>
                                    <ul>
                                        <li>The smallest lot size in your trading history becomes your base lot size.</li>
                                        <li>No trade may exceed 5× the base lot size.</li>     
                                        <li>The rule is applied individually per instrument.</li>
                                    </ul>
                                    
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Example — XAU/USD</div>
                                    <p>If your smallest historical trade is:</p>
                                    <p>1.0 lot → Base lot = 1.0</p>
                                    <p>Permitted range: 1 to 5 lots</p>
                                    <p>Valid trades: 1, 2, 3, 4, or 5 lots</p>

                                    <p className='mt-3'>If you open 0.9 lot, the base resets to 0.9.</p>
                                    <p>Your new maximum allowed trade becomes 4.5 lots.</p>
                                   
                                    
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Additional Notes</div>
                                    <ul>
                                        <li>Trades opened within 3 minutes, on the same symbol and in the same direction, are treated as a single trade.</li>
                                        <li>The assessment is conducted per instrument, as lot sizing varies across asset classes (Forex, Metals, Crypto, etc.).</li>
                                    </ul> 
                                </div>      

                                 <div className="legal-content">
                                    <div className="legal-heading">In Case of Violation</div>
                                        <p>FundedSkill continuously monitors all accounts to ensure compliance with the outlined parameters.</p>
                                        <p>If trading behavior falls outside the defined framework, the account may be reviewed, restricted, or permanently breached.</p>
                                </div>   

                                 {/* <div className="legal-content">
                                    <div className="legal-heading">The Principle</div>
                                    <p>We are not here to restrict you.</p>
                                    <p>We are here to eliminate self-destructive patterns that separate short-term luck from long-term skill.</p>

                                    <p className='mt-3'>Trade with structure.</p>
                                    <p> Size with intent.</p>
                                    <p>Protect capital first.</p>
                                </div>     */}

                                
                                 <div className="legal-content">
                                    <div className="legal-heading">5. Payout Policy</div>
                                    <p>At FundedSkill, performance is rewarded transparently and consistently</p>
                                    <p> Our payout structure is designed to incentivize disciplined profitability — not short-term spikes.</p>

                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">Payout Eligibility</div>
                                    <p>To qualify for any payout, traders must generate a minimum of:</p>
                                    <p> 1% net profit on their live funded account.</p>
                                     <p>This threshold ensures payouts reflect:</p>

                                     <ul>
                                        <li>Meaningful trading performance</li>
                                        <li>Responsible capital management</li>
                                        <li>Sustained profitability</li>
                                     </ul>

                                     <p className='mt-3'>Payouts are based on net profit after respecting all risk parameters and rules.</p>

                                </div>
                                
                                <div className="legal-content">
                                    <div className="legal-heading">Payout Schedule</div>
                                    <p>Traders can select their preferred payout cycle at enrollment:</p>

                                     <ul>
                                        <li>Weekly</li>
                                        <li>Biweekly</li>
                                        <li>Monthly</li>
                                     </ul>

                                     <p className='mt-3'>Each option comes with a defined profit-sharing structure.</p>

                                </div>    

                                <div className="legal-content">
                                    <div className="legal-heading">Profit Share Structure</div>
                                   <table className="custom-table mt-4 mb-2">
                                        <thead>
                                            <tr>
                                                <th>Payout Frequency</th>
                                                <th>Profit Share</th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr>
                                                 <td >Monthly</td>
                                                <td>Up to 100%</td>
                                               
                                            </tr>
                                            <tr>
                                                <td >Biweekly</td>
                                                <td>80%</td>
                                            </tr>
                                            <tr>
                                                <td >Weekly</td>
                                                <td>60%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">Monthly Plan</div>
                                    <p>Traders opting for monthly payouts are eligible to receive up to 100% of their shareable profits, maximizing long-term earnings.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Biweekly & Weekly Plans</div>
                                    <p>For traders who prefer more frequent withdrawals:</p>

                                    <ul>
                                        <li>Biweekly payout → 80% profit share</li>
                                        <li>Weekly payout → 60% profit share</li>
                                    </ul>

                                    <p className='mt-3'>Frequent liquidity comes with adjusted distribution.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Weekly & Biweekly Release Schedule</div>
                                    <p>For weekly and biweekly plans:</p>

                                    <ul>
                                        <li>Payouts are processed every Wednesday</li>
                                        <li>The first payout becomes eligible starting from the second week after the live account is activated</li>
                                    </ul>

                                    <p className='mt-3'>This structure ensures consistent accounting cycles and transparent profit calculation.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">6. Evaluation Fee Refund</div>
                                    <p>At FundedSkill, we believe commitment and performance should be rewarded.</p>

                                    <p>All traders who successfully pass the evaluation process and reach funded status will receive a full refund of their evaluation fee, issued alongside their 4th payout.</p>
                                    <p>This ensures that traders who demonstrate consistency and professionalism are fully compensated — not just through profit share, but through returned capital as well.</p>

                                    <p className='mt-3'>Your performance earns your funding</p>
                                    <p> Your consistency earns your refund.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">7. Disclaimer</div>
                                    
                                </div>  

                                
                                <div className="legal-content">
                                    <div className="legal-heading">Slippage & Volatility Policy</div>
                                    <p>Financial markets are dynamic and, at times, highly volatile. During periods of increased volatility — particularly around major economic releases, geopolitical developments, or unexpected liquidity shifts — slippage may occur.</p>

                                    <p>This means that orders, including stop-loss and pending orders, may be executed at prices different from those requested due to real-time market liquidity and execution conditions provided by liquidity providers.</p>
                                    <p>Please note:</p>

                                     <ul>
                                        <li>Slippage is a natural market phenomenon.</li>
                                        <li>Execution prices cannot be guaranteed during extreme volatility.</li>
                                        <li>Both positive and negative slippage may occur.</li>
                                     </ul>
                                    <p className='mt-3'> If slippage results in a breach of daily or overall drawdown limits, the violation will be considered valid and the account will be treated accordingly.</p>
                                    <p>FundedSkill does not adjust or reverse breaches caused by market-driven execution conditions.</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Built for Consistency. Not Gambling.</div>
                                    <p>FundedSkill is structured to reward disciplined, process-driven traders — not event-driven speculation.</p>

                                    <p>If more than 80% of total profit is generated from:</p>
                                    

                                     <ul>
                                        <li>A single trade</li>
                                        <li>A single high-impact news event</li>
                                        <li>All-in positions during major economic releases</li>
                                        <li>Mirrored or opposing trades across multiple accounts</li>
                                        <li>Strategies designed to intentionally fail one account to pass another</li>
                                     </ul>
                                    <p className='mt-3'> Your account may be subject to review.</p>
                                    <p>We reserve the right to evaluate trade intent, timing, and overall risk structure to ensure fair participation across the program.</p>
                                    <p>Traders who apply structured risk management and consistent execution practices are not affected.</p>
                                </div>
                            </div>

                            {/* Step 3 Rules btn */}
                            <div className={`row row-gap-0 ${tab === 'step3rulesTab' ? '' : 'd-none'} `} id="acActive">
                               
                                 <div className="legal-content">
                                    <p>At FundedSkill, we know skilled traders need the right environment to apply their methods effectively. Our setup offers broad market access and practical leverage, free from overly restrictive policies.</p>
                                </div>
                                <div className="legal-content">
                                    <div className="legal-heading">1. Trade What You Want. Trade How You Want.</div>
                                    <p>At FundedSkill, we understand that serious traders don’t just need market access — they need the right conditions to execute with precision.</p>
                                    <p>Our infrastructure is designed to support strategic trading across multiple asset classes, with meaningful leverage and zero unnecessary restrictions.</p>
                                   <p>This is your edge. Use it wisely.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.1 Tradable Instruments</div>
                                    <p>We provide access to a diversified selection of global markets, allowing you to specialize or diversify based on your strategy and risk tolerance.</p>
                                    <p>You can trade:</p>
                                    <ul>
                                        <li>Foreign Exchange (Forex)</li>
                                        <li>Precious Metals</li>
                                        <li>Global Indices</li>
                                        <li>Energy Commodities</li>
                                        <li>Cryptocurrencies</li>
                                    </ul>
                                    <p className='mt-3'>Built for flexibility. Structured for performance.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">1.2 Leverage Policy</div>
                                    <p>Leverage is a tool — and in the hands of a disciplined trader, it becomes a strategic advantage.</p>
                                    <p>To support capital efficiency while maintaining responsible risk parameters, we offer:s</p>
                                    <table className="custom-table mt-4 mb-2">
                                        <thead>
                                            <tr>
                                                <th>Asset Class</th>
                                                <th>Leverage</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td >Forex</td>
                                                <td>1:30</td>
                                               
                                            </tr>
                                            <tr>
                                                <td >Metals</td>
                                                <td>1:30</td>
                                            </tr>
                                            <tr>
                                                <td >Indices</td>
                                                <td>1:30</td>
                                            </tr>
                                            <tr>
                                                <td >Energies</td>
                                                <td>1:30</td>
                                            </tr>
                                            <tr>
                                                <td >Crypto</td>
                                                <td>1:30</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>Our leverage structure is designed to give you operational room — even during volatile market conditions — without encouraging reckless exposure.</p>
                                    <p>Trade smart. Trade structured. Trade with intent.</p>

                                    <p className="mt-3">You’re right — this needs rephrasing, not just heading suggestions.</p>
                                    <p> Here’s a cleaner, more professional rewrite of your section with improved clarity and consistency while keeping your rules intact.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2. Strategy & Execution Freedom</div>
                                    <p>At FundedSkill, we believe professional traders perform best when unnecessary restrictions are removed.</p>
                                    <p>We don’t interfere with your strategy. We provide the structure — you provide the edge.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.1 Weekend & Overnight Holding</div>
                                    <p>Markets don’t operate on artificial timelines — and neither should you.</p>
                                    <p>Some setups require patience. Others need room to develop across sessions. That’s why we impose no restrictions on overnight or weekend holding.</p>
                                    <p>You are free to:</p>
                                    <ul>
                                        <li>Hold positions overnight</li>
                                        <li>Carry trades through multiple sessions</li>
                                        <li>Maintain swing trades over the weekend</li>
                                    </ul>
                                    <p className='mt-3'>Whether you're positioning around macro narratives or riding a sustained trend, your trades won’t be closed due to arbitrary firm policies.</p>
                                    <p>Your strategy. Your timing.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">2.2 News Trading — Fully Allowed</div>
                                    <p>News is not an exception to the market. It is the market.</p>
                                    <p>We allow news trading in all forms, including:</p>
                                    <ul>
                                        <li>Central bank decisions</li>
                                        <li>Major economic releases</li>
                                        <li>Inflation data</li>
                                        <li>Geopolitical developments</li>
                                    </ul>
                                    <p className='mt-3'>If your edge is built around fundamentals or short-term volatility, you are free to execute.</p>
                                    <p>Fast markets create opportunity — and disciplined traders know how to navigate them.</p>
                                    <p>You are trusted to trade responsibly, even when volatility expands.</p>
                                </div>

                                <div className="legal-content">
                                    <p>At FundedSkill, you are allowed to place multiple trades on the same pair; however, how they are classified depends on the time gap between them. To treat trades as separate orders, there must be at least a three-minute gap.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading mt-3">2.3 Take Your Time</div>
                                    <p>Performance thrives without artificial pressure.</p>
                                    <p>That’s why there is no maximum time limit to complete your challenge.</p>
                                    <p>Whether it takes days or weeks, you can progress at your own pace. We care about consistency — not speed.</p>
                                    <p className='mt-3'>Trade when conditions align.</p>
                                    <p > Wait when they don’t.</p>
                                    <p> Let your system work.</p>
                                
                                    <div className="legal-heading mt-3">3. Trading Framework (Instant Model)</div>
                                    <p>At FundedSkill, we offer three funding models — Instant, Step 1, and Step 2 — each designed to evaluate a trader’s discipline, consistency, and risk management skills. Every account type operates under clearly defined rules and performance objectives.</p>
                                    <p>The framework outlined below applies specifically to the Instant Model. It is structured to identify traders who demonstrate not only effective strategies, but also the discipline and mindset required to responsibly manage capital.</p>
                                      
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Minimum Trading Requirement</div>
                                    <p>To qualify for a payout, traders must trade on at least five (5) separate trading days.</p>
                                    <p>For a trading day to be counted, a minimum profit of 0.5% of the account balance must be achieved on that day.</p>
                                    <p>This rule ensures consistent performance and discourages passing the evaluation through a single high-risk trade.</p>
                                    
                                </div>

                                  <div className="legal-content">
                                    <div className="legal-heading">Example:</div>
                                    <p> For a $5,000 account, a minimum daily profit of $25 (0.5%) is required for that day to qualify.</p>
                                    
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Trading Inactivity Policy</div>
                                    <p>All accounts are expected to maintain consistent trading activity.</p>
                                    <p >If no trades are placed for 30 consecutive calendar days, the account will be considered inactive and may be permanently disabled.</p>
                                    <p>This policy ensures that funded capital is allocated to active and committed traders. If you anticipate an extended break, you must inform the team in advance to prevent unintended violations.</p>
                                    
                                </div>
                                    
                                    <div className="legal-content">
                                    <div className="legal-heading">Maximum Daily Drawdown</div>
                                    <p>The maximum daily drawdown is set at 3% of the higher value between the starting balance or starting equity at the beginning of the trading day.</p>
                                    <p>This limit is fixed for the day and does not increase based on intraday profits.</p>
                                     <p>If, at any time during the day, your equity falls below the daily drawdown threshold — whether due to floating or closed losses — the account will be breached.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Example:</div>
                                    <p>If your starting balance and equity are $500, the daily drawdown limit is 3% ($15). Your equity must remain above $485 throughout the trading day.</p>
                                    <p>  If on the next day your balance is $510 and you carry a floating profit of $10, your starting equity becomes $520. The daily drawdown limit is 3% of $520 ($15.60). Your equity must remain above $504.40 for that day.</p>
                                     <p>Intraday gains do not increase the allowable loss buffer. Both floating and realized losses are included in the calculation.</p>
                                     
                                </div>

                                   

                                 <div className="legal-content">
                                    <div className="legal-heading">Maximum Total Drawdown</div>
                                    <p>The maximum overall drawdown is fixed at 5% of the initial account balance.</p>
                                    <p>Your equity or balance must never fall below 95% of the starting balance, at any time.</p>
                                    <p>Both floating and closed losses are included in this calculation.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p > If your initial balance is $500, the maximum permitted loss is $25. Your equity or balance must remain above $475 at all times.</p>
                                    <p>This limit remains fixed and does not adjust upward based on profits.</p>
                                     
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Drawdown Breach Policy</div>
                                    <p >If your equity falls below either the daily or total drawdown limit at any time — whether from floating or closed losses — the account will be immediately breached and permanently terminated.</p>
                                    
                                     <p>Strict adherence to drawdown limits is mandatory to continue evaluation or maintain funded status. Traders are responsible for monitoring their live equity at all times.</p>
                                    
                                   
                                </div>  

                                 <div className="legal-content">
                                    <div className="legal-heading">Important Operational Notes</div>
                                    <ul>
                                        <li>Trades opened within three (3) minutes on the same symbol and in the same direction will be treated as a single trade.</li>
                                        <li>The system resets the starting balance and equity daily at 10:00 PM UTC.</li>
                                    </ul>
                                </div> 

                                <div className="legal-content">
                                    <div className="legal-heading">4. Destructive Trading Practices</div>
                                    <p>At FundedSkill, our objective is not only to help traders pass an evaluation, but to foster disciplined decision-making that supports long-term consistency.</p>
                                    <p>Trading environments can be fast-moving and emotionally demanding. However, certain behaviors — even if they seem minor in the moment — can quickly escalate into significant risk exposure. In a proprietary trading structure, these actions impact both individual accounts and the integrity of the overall program.</p>
                                    <p>This section outlines trading behaviors that are considered destructive and may result in violations, along with guidance on how to avoid them.</p>
                                    
                                </div>   

                                 <div className="legal-content">
                                    <div className="legal-heading">4.1 Gambling Behavior</div>
                                    <p>Trading must be based on structured analysis and calculated risk — not chance.</p>
                                    <p>Placing excessively large or high-risk positions that can consume the daily drawdown in a single movement is considered gambling behavior. To promote responsible risk management:</p>
                                    <p>No single trade may risk more than 1% of the account balance.</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p> On a $10,000 account, the maximum permissible loss on any single trade is $100.</p>
                                   
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">Important Note:</div>
                                    <p>Multiple positions opened on the same instrument, in the same direction, within three (3) minutes will be treated as a single trade for drawdown calculations. The combined floating and realized loss from such entries must remain within the 1% limit.</p>
                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">4.2 Conflicted Trade Bias (Internal Hedging)</div>

                                    <p>Opening opposing positions on the same instrument at the same time is not permitted.</p>
                                    <p>While placing both a buy and sell position on the same asset may appear to reduce risk, it eliminates directional conviction and creates artificial exposure that does not reflect structured trade intent.</p>
                                    
                                    </div>


                                     <div className="legal-content">
                                    <div className="legal-heading">Example</div>
                                    <p>Opening a buy position on XAUUSD at 3220 and a sell position at 3240 simultaneously is prohibited.</p>
                                    <p>Traders must maintain a clear directional bias and execute trades based on structured analysis rather than attempting to hedge against their own positions.</p>
                                    <p>Holding both long and short positions on the same instrument at the same time is not allowed.</p>
                                  </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">4.3 Excessive Trade Dependence</div>
                                    <p>Consistent payouts should reflect repeatable skill — not reliance on a single oversized gain.</p>
                                  
                                    <p>If one trade contributes a disproportionate share of total profits, it often indicates excessive risk exposure rather than sustainable strategy execution.</p>
                                    <p>To encourage balanced performance:</p>
                                    <p>No single trade may account for more than 20% of the total payout amount.</p>
                                    
                                </div>  

                               

                                <div className="legal-content">
                                    <div className="legal-heading">Note:</div>
                                    <p> Multiple entries placed within three (3) minutes on the same instrument and in the same direction may be treated as a single position when calculating payout contribution.</p>
                                </div>      

                                 <div className="legal-content">
                                    <div className="legal-heading">Violation & Enforcement Policy</div>
                                        <p>FundedSkill actively monitors all accounts to ensure compliance with the trading standards outlined above.</p>
                                        <p>If prohibited behavior is detected, the firm reserves the right to issue:</p>
                                        <ul>
                                            <li>A soft breach (warning or corrective action), or</li>
                                            <li>A full breach, resulting in permanent account termination,</li>
                                        </ul>
                                        <p className='mt-3'>in accordance with the program’s terms and conditions.</p>
                                        <p>Maintaining disciplined execution and structured risk management is essential to remaining eligible for funding and payouts.</p>
                                </div>   

                                

                                
                                 <div className="legal-content">
                                    <div className="legal-heading">5. Payout Policy</div>

                                </div>    

                                 <div className="legal-content">
                                    <div className="legal-heading">Payout Eligibility</div>
                                    <p>To qualify for a payout, traders must generate a minimum of 1% net profit based on their live account size.</p>
                                    <p> This threshold ensures that payouts reflect meaningful performance and consistent profitability rather than short-term fluctuations.</p>
                                     <p>Only accounts in full compliance with all trading rules and risk parameters will be considered eligible for withdrawal.</p>


                                </div>
                                
                                <div className="legal-content">
                                    <div className="legal-heading">Payout Structure & Schedule</div>
                                    <p>Payout frequency and profit share depend on the plan selected at the time of enrollment.</p>


                                </div>    

                                <div className="legal-content">
                                    <div className="legal-heading">On-Demand Payout Plan</div>
                                  <p>Traders who select the on-demand payout option are eligible to receive up to 60% of shareable profits.</p>
                                  <p> Payout requests may be submitted at any time once eligibility requirements are met.</p>
                                </div>  

                                
                                <div className="legal-content">
                                    <div className="legal-heading">Weekly Payout Plan</div>
                                  <p>Traders who opt for the weekly payout structure are eligible to receive 80% of shareable profits.</p>
                                  <p> Weekly payouts are processed every Wednesday, beginning from the second week after the account activation date, provided all payout conditions are satisfied.</p>
                                </div>  

                                

                                <div className="legal-content">
                                    <div className="legal-heading">6. Evaluation Fee Refund</div>
                                    <p>At FundedSkill, we believe commitment and performance should be rewarded.</p>

                                    <p>All traders who successfully pass the evaluation process and reach funded status will receive a full refund of their evaluation fee, issued alongside their 4th payout.</p>
                                    <p>This ensures that traders who demonstrate consistency and professionalism are fully compensated — not just through profit share, but through returned capital as well.</p>

                                    <p className='mt-3'>Your performance earns your funding</p>
                                    <p> Your consistency earns your refund.</p>
                                </div>  

                                <div className="legal-content">
                                    <div className="legal-heading">7. Disclaimer</div>
                                    
                                </div>  

                                
                                <div className="legal-content">
                                    <div className="legal-heading">Slippage & Volatility Policy</div>
                                    <p>Financial markets are dynamic and, at times, highly volatile. During periods of increased volatility — particularly around major economic releases, geopolitical developments, or unexpected liquidity shifts — slippage may occur.</p>

                                    <p>This means that orders, including stop-loss and pending orders, may be executed at prices different from those requested due to real-time market liquidity and execution conditions provided by liquidity providers.</p>
                                    <p>Please note:</p>

                                     <ul>
                                        <li>Slippage is a natural market phenomenon.</li>
                                        <li>Execution prices cannot be guaranteed during extreme volatility.</li>
                                        <li>Both positive and negative slippage may occur.</li>
                                     </ul>
                                    <p className='mt-3'> If slippage results in a breach of daily or overall drawdown limits, the violation will be considered valid and the account will be treated accordingly.</p>
                                    <p>FundedSkill does not adjust or reverse breaches caused by market-driven execution conditions.</p>
                                </div>

                                 <div className="legal-content">
                                    <div className="legal-heading">Built for Consistency. Not Gambling.</div>
                                    <p>FundedSkill is structured to reward disciplined, process-driven traders — not event-driven speculation.</p>

                                    <p>If more than 80% of total profit is generated from:</p>
                                    

                                     <ul>
                                        <li>A single trade</li>
                                        <li>A single high-impact news event</li>
                                        <li>All-in positions during major economic releases</li>
                                        <li>Mirrored or opposing trades across multiple accounts</li>
                                        <li>Strategies designed to intentionally fail one account to pass another</li>
                                     </ul>
                                    <p className='mt-3'> Your account may be subject to review.</p>
                                    <p>We reserve the right to evaluate trade intent, timing, and overall risk structure to ensure fair participation across the program.</p>
                                    <p>Traders who apply structured risk management and consistent execution practices are not affected.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
